import React from "react";

import { SETTINGS_TABS } from "../../contents/constants";
import Account from "../account";
import EmailNotifications from "../email-notifications";
import Profile from "../profile";

type ActiveTabComponentProps = {
  isMobile: boolean;
  activeLabel: string;
  activeTab: string;
};

const ActiveTabComponent = ({
  isMobile,
  activeLabel,
  activeTab,
}: ActiveTabComponentProps) => {
  const renderComponentBasedOnTab = (tabName: string) => {
    switch (tabName) {
      case SETTINGS_TABS.PROFILE.name:
        return <Profile />;
      case SETTINGS_TABS.EMAIL_NOTIFICATION.name:
        return <EmailNotifications />;
      case SETTINGS_TABS.ACCOUNT.name:
        return <Account />;
      default:
        return <div>Tab not found</div>;
    }
  };
  return (
    <>
      {activeLabel && isMobile && (
        <div
          className={`setptings-content-container m-3 ${isMobile ? "mt-0" : ""}md:mx-10 md:my-3 md:w-[55%]`}
        >
          {renderComponentBasedOnTab(activeTab)}
        </div>
      )}

      {!isMobile && (
        <div
          className={`setptings-content-container m-3 ${isMobile ? "mt-0" : ""}md:mx-10 md:my-3 md:w-[55%]`}
        >
          {renderComponentBasedOnTab(activeTab)}
        </div>
      )}
    </>
  );
};

export default ActiveTabComponent;
